import { Slide } from "@jelly/lesson";

import { task as task01 } from "../../../../../task/course-05/lesson-07/task-01";
import config from "appConfig";

const task: Slide = {
  titleHtml:
    "A directional loudspeaker with the sensitivity level of 93 dB/1W/1m and the on-axis<br>directivityindex of 8 dB is placed into a shoe-box shaped room that is 20 meters<br>long, 14 meters wide, and 8 meters high. The measured reverberation time in the<br>room is 3 seconds. If the loudspeaker is fed with 10 W of electrical power, calculate:",
  description: "Fill in the value.",
  layout: {
    type: "table",
    options: {
      cols: 1,
      rows: 3,
      rowsSize: [3, 3, 1],
      components: [
        [
          {
            variant: "blockContainer",
            data: {
              block: {
                type: "text",
                options: {
                  scrollbars: false,
                  formatter: "html",
                  data:
                    "The level of direct sound for a listener standing 45° off axis of the loudspeaker at a distance of 6 meters.</br>The radiation pattern of the loudspeaker reveals that the sound pressure level produced by the loudspeaker in this particular direction is 6 dB lower than on axis.",
                },
              },
              styles: {
                alignItems: "flex-end",
                textAlign: "center",
              },
            },
          },
        ],
        [
          {
            variant: "__task__",
            data: {
              id: task01.id,
            },
          },
        ],
        [
          {
            variant: "blockContainer",
            data: {
              block: {
                type: "image",
                options: {
                  src: `${config.ASSETS_URL}/05/07/task/task-label.svg`,
                },
              },
              styles: {
                padding: "1%",
              },
            },
          },
        ],
      ],
    },
  },
};

export default task;
